import { render } from "./addTracks.vue?vue&type=template&id=5d5ea9ec"
import script from "./addTracks.vue?vue&type=script&lang=js"
export * from "./addTracks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__